module.exports = __webpack_public_path__ + "static/Hingham-Beer-Works-TN-545602c6bd4a92de71d7400376340a2b.jpg";